import RandingStyle4 from "../../randing/RandingStyle4";
import RandingStyle7 from "../../randing/RandingStyle7";
import RandingStyle9 from "../../randing/RandingStyle9";

function Randing181({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/181/250203_01.gif`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/087/250203_04.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      formFieldColor="white"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      benefitInfoPosition="bottom"
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
      apiUrl={apiUrl}
    />
  );
}

export default Randing181;
